import {
    ARTICLES_TITLE,
    STROLLER_STROLLEROPEDIA,
    STROLLEROPEDIA_NEW_ARTICLES_LONG,
} from 'mk/autogenerated/translations/ArticlesOfSections.5a1211267a0766732e769ca9c4750de9'
import StrollersArticleSectionPills from 'mk2/apps/strollers/components/StrollersArticleSectionPills';
import { ArticlesOfSection } from 'mk2/apps/strollers/containers/ArticlesOfSections/ArticlesOfSection';
import {
    RECENT_SECTION,
    SECTIONS_CONFIG,
} from 'mk2/apps/strollers/containers/ArticlesOfSections/ArticlesOfSections.constants';
import { Props } from 'mk2/apps/strollers/containers/ArticlesOfSections/ArticlesOfSectionsPage';
import { strollersArticlesUrl, strollersUrl } from 'mk2/apps/strollers/urls';
import { BreadcrumbSiteStructure } from 'mk2/components/BreadcrumbSiteStructure';
import { Link } from 'mk2/components/Link';
import { LoadingState } from 'mk2/reducers/loadingState';
import React from 'react';
import styles from './ArticlesOfSections.mscss';

export class ArticlesOfSections extends React.Component<Props> {
    public static getBreadcrumbItems(currentSectionSlug) {
        const breadcrumbLinks = [];
        breadcrumbLinks.push(
            <Link className={styles.BreadcrumbItem} key="strolleropedia" to={strollersUrl}>
                {STROLLER_STROLLEROPEDIA}
            </Link>,
        );
        if (!currentSectionSlug) {
            breadcrumbLinks.push(<React.Fragment key="allSections">{ARTICLES_TITLE}</React.Fragment>);
        } else {
            breadcrumbLinks.push(
                <Link className={styles.BreadcrumbItem} key="allSections" to={strollersArticlesUrl}>
                    {ARTICLES_TITLE}
                </Link>,
            );
            breadcrumbLinks.push(<React.Fragment key="section">{SECTIONS_CONFIG[currentSectionSlug].label}</React.Fragment>);
        }
        return breadcrumbLinks;
    }

    public render() {
        const {
            currentSectionSlug,
            onLoad,
            allArticles,
            sectionsData,
        } = this.props;

        return (
            <div className={styles.ArticlesOfSections}>
                <BreadcrumbSiteStructure
                    items={ArticlesOfSections.getBreadcrumbItems(currentSectionSlug)}
                    className={styles.ArticlesOfSections__breadcrumb}
                />
                <div className={styles.ArticlesOfSections__sectionFilter}>
                    <StrollersArticleSectionPills
                        currentSectionSlug={currentSectionSlug}
                    />
                </div>
                <ArticlesOfSection
                    title={this.getLabel(SECTIONS_CONFIG[currentSectionSlug])}
                    titleIcon={SECTIONS_CONFIG[currentSectionSlug].icon}
                    sectionSlug={currentSectionSlug}
                    allArticles={allArticles}
                    articleIdsOfSection={sectionsData[currentSectionSlug]?.articleIds}
                    loadingState={
                        sectionsData[currentSectionSlug] ? sectionsData[currentSectionSlug].loadingState : LoadingState.INIT
                    }
                    errorMessage={sectionsData[currentSectionSlug]?.errorMessage}
                    hasMore={sectionsData[currentSectionSlug]?.hasMore}
                    after={
                        sectionsData[currentSectionSlug]?.hasMore
                            ? sectionsData[currentSectionSlug]?.articleIds[
                                sectionsData[currentSectionSlug]?.articleIds.length - 1
                            ]
                            : null
                    }
                    onLoad={onLoad}
                />
            </div>
        );
    }

    private getLabel(section) {
        return section.sectionSlug === RECENT_SECTION
            ? STROLLEROPEDIA_NEW_ARTICLES_LONG
            : section.label;
    }
}
